import url from './url';



export default url(() => '/rbac/roles');
